import React from "react";
import Form from "react-bootstrap/Form";
import { TriyoForm } from "../../../../../components/TriyoForm";
import { FluentTime } from "../../../../../components/FluentUI/Fluent-Time";
import "./template-task-creation.scss";
import { getTimeFromTimeStamp } from "../../../../../util/time-helpers";
import taskRecurrenceIcon from "../../../../../assets/icons/Task-Recurrence-16px-Blue-60.svg";
import DropdownMain from "../../../../../components/dropdown-main/DropdownMain";
import { recurringStartDayOfWeekValues, recurringValues } from "../template-task-utility";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormMiddleRecurrenceNew = ({
  values,
  handleChange,
  touched,
  errors,
  setFieldValue,
}) => {
  return (
    <div className="task-accordion-container">
      <div className="heading">
        <div className="heading-description">
          <img className="heading-image" alt="Task Recurrence" src={taskRecurrenceIcon} />
          <h4 className="heading-name">Set Task Recurrence</h4>
        </div>
        <TriyoForm.Toggle
          checked={values?.Recurring != null && values?.Recurring !== ""}
          onChange={(e) => {
            let value = e.target.checked ? recurringValues[0] : "";
            setFieldValue("Recurring", value ? value.name : "");
          }}
        />
      </div>
      <div className={values?.Recurring ? "show" : "no-show"}>
        <div className="elements-container">
          <div className="left-element">
            <DropdownMain
              values={recurringValues}
              dropdownButtonText={"-Select-"}
              onSelect={(selectedValue) => {
                setFieldValue("Recurring", selectedValue.name);
                setFieldValue("RecurringImmediate", false);
              }}
              currentSelected={recurringValues.find(
                (val) => val.name === values.Recurring
              )}
            />
          </div>
          <div className="mid-element"></div>

          <div className="right-element">
            <FluentTime
              value={new Date(values.RecurringStartDateTime)}
              onChange={(value) =>
                setFieldValue("RecurringStartDateTime", value)
              }
              timeIntervals={15}
            />
          </div>
        </div>
        <div
          className={`elements-container ${
            values?.Recurring !== "Daily" ? "show" : "no-show"
          }`}
        >
          <div className="left-element">
            <div className="bool-container">
              <div
                onClick={() => {
                  setFieldValue("RecurringStartDayOfWeek", "ProjectStart");
                  setFieldValue("RecurringImmediate", false);
                }}
              >
                <Form.Check
                  type="checkbox"
                  checked={values.RecurringStartDayOfWeek === "ProjectStart"}
                  label="From Project Start Date"
                />
              </div>
              <div
                onClick={() => {
                  setFieldValue("RecurringStartDayOfWeek", "Sundays");
                }}
              >
                <Form.Check
                  type="checkbox"
                  checked={values.RecurringStartDayOfWeek !== "ProjectStart"}
                  label="On Specific Day"
                />
              </div>
            </div>
          </div>
          <div className="mid-element"></div>
          <div
            className={`right-element ${
              values.RecurringStartDayOfWeek !== "ProjectStart"
                ? "show"
                : "no-show"
            }`}
          >
            <DropdownMain
              values={recurringStartDayOfWeekValues}
              dropdownButtonText={"-Select-"}
              onSelect={(selectedValue) => {
                setFieldValue("RecurringStartDayOfWeek", selectedValue.name);
              }}
              currentSelected={recurringStartDayOfWeekValues.find(
                (val) => val.name === values.RecurringStartDayOfWeek
              )}
            />
          </div>
        </div>
        {(values?.Recurring === "Weekly" || values?.Recurring === "Monthly") &&
          values?.RecurringStartDayOfWeek !== "ProjectStart" && (
            <div>
              <h4 className="recurrence-details">
                <strong>Generate First Task</strong>
                <br />
              </h4>
              <h4 className="recurrence-details">
                <Form.Group className="template-task-recurring-immediate">
                  <Form.Check
                    className="template-task-left-permission"
                    type="radio"
                    name="RecurringImmediate"
                    checked={!values.RecurringImmediate}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("RecurringImmediate", false);
                    }}
                    label="Based on the recurring schedule"
                    isInvalid={
                      touched.RecurringImmediate && errors.RecurringImmediate
                    }
                  />
                  <br />
                  <Form.Check
                    className="template-task-right-permission"
                    type="radio"
                    name="RecurringImmediate"
                    checked={values.RecurringImmediate}
                    onChange={(e) => {
                      handleChange(e);
                      setFieldValue("RecurringImmediate", true);
                    }}
                    label="Immediately on launching the Project"
                    isInvalid={
                      touched.RecurringImmediate && errors.RecurringImmediate
                    }
                  />
                  <Form.Control.Feedback
                    type="invalid"
                    className="inline-error"
                  >
                    {errors.RecurringImmediate}
                  </Form.Control.Feedback>
                </Form.Group>
              </h4>
            </div>
          )}

        <h4 className="recurrence-details">
          Task will be created
          {values?.Recurring !== "Daily"
            ? ` once ${values?.Recurring?.toLowerCase()} `
            : " daily "}
          {values?.Recurring !== "Daily" &&
            (values?.RecurringStartDayOfWeek !== "ProjectStart"
              ? `on ${values.RecurringStartDayOfWeek} `
              : `starting on project start date `)}
          {"at " + getTimeFromTimeStamp(values.RecurringStartDateTime)}
        </h4>
      </div>
    </div>
  );
};

TemplateTaskCreationPanelFormMiddleRecurrenceNew.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};
export default TemplateTaskCreationPanelFormMiddleRecurrenceNew;
